import React, { useEffect } from "react";
import { connect } from "react-redux";
import ScrollIntoView from "../../../shared/scroll-into-view/scroll-into-view";
import {
  fetchAvailability,
  updatePersonAvailability,
  updateAvailability,
  clearUpdatedPeople
} from "./ducks/actions";
import Availability from "./availability";
import Loader from "../../../shared/loader";
import moment from "moment";

const SchedulingContainer = (props) => {
  const filmId = props.match.params.filmId;
  const {
    fetchAvailability,
    loading,
    saving,
    potentialDates,
    actorsAvailability,
    backgroundActorsAvailability,
    crewMemberAvailability,
    locationsAvailability,
    readOnly,
    canAccessActors,
    canAccessBackgroundActors,
    canAccessCrew,
    datesTotals,
    refetch,
    filmName,
    updatePersonAvailability,
    updateAvailability,
    clearUpdatedPeople,
    updatedPeople } = props;

  useEffect(() => {
    fetchAvailability(filmId, false);
  }, []);

  useEffect(() => {
    if (refetch) {
      fetchAvailability(filmId, refetch);
    }
  }, [refetch]);

  const csvData: any[] = [];
  var filteredDates = potentialDates;

  const addPeopleToCsv = (csvData: any[], people: any[], filteredDates: any[], isLocation: boolean) => {
    if (people?.length > 0) {
      people.forEach(actor => {

        const line = [actor.name, actor.hasSubmitted];
        if (isLocation) {
          //debugger;
        }
        const availableDates = isLocation ? convertFromLocal(actor.availableDates) : actor.availableDates;

        (filteredDates || []).forEach((potentialDate: any, index: number) => {
          line.push((availableDates || []).some((availableDate) => availableDate == potentialDate.date) ? "Available" : "");
        });
        csvData.push(line);
      });
    }
  };

  const convertToUTC = (localDates) => {
    return localDates.map((date) => {
      const localDate = new Date(date); // Parse the local date
      return new Date(Date.UTC(
        localDate.getFullYear(),
        localDate.getMonth(),
        localDate.getDate(),
        localDate.getHours(),
        localDate.getMinutes(),
        localDate.getSeconds()
      ));
    });
  };

  const convertFromLocal = (localDates) => {
    return localDates.map((date) => {
      const localDate = new Date(date).toUTCString(); // Parse the local date
      return new Date(localDate).toUTCString();
    });
  };

  addPeopleToCsv(csvData, actorsAvailability, filteredDates, false);
  addPeopleToCsv(csvData, backgroundActorsAvailability, filteredDates, false);
  addPeopleToCsv(csvData, crewMemberAvailability, filteredDates, false);
  addPeopleToCsv(csvData, locationsAvailability, filteredDates, true);

  // const csvData = (overview?.shots || []).map((shot: any) => {
  //     return [shot.number, shot.shotSizeDescription, shot.lensFocalLength, shot.movementDescriptions, shot.characters, shot.backgroundCharacters, shot.frameRate, formatTime(shot.estimatedSetupDuration), formatTime(shot.estimatedShootingDuration), formatTime(shot.estimatedTotalShootingDuration), shot.notes];
  //   });

  const datesTotalLine = ["Total", ""];
  (datesTotals || []).forEach((total: any, index: number) => {
    datesTotalLine.push(total);
  });

  csvData?.unshift(datesTotalLine);

  const headerLine = ["Person Name", "Has Submitted"];
  (filteredDates || []).forEach((day: any, index: number) => {
    headerLine.push(moment(day).format("YYYY-MM-DD"));
  });

  csvData?.unshift(headerLine);

  const onUpdateAvailability = () => {
    updateAvailability(filmId, updatedPeople,
      actorsAvailability,
      backgroundActorsAvailability,
      crewMemberAvailability,
      locationsAvailability
    );
  }

  const onCancelAvailabilityEdit = () => {
    clearUpdatedPeople();
    fetchAvailability(filmId, true);
  }

  const hasChanges = updatedPeople && updatedPeople.size > 0;

  return (
    <ScrollIntoView
      className="blade-content wider"
      path="/films/:filmId/scheduling"
      loading={loading}>
      <h2 className="menu-label">Availability</h2>
      {(loading || saving) && <Loader />}
      {!loading && <Availability
        potentialDates={potentialDates}
        datesTotals={datesTotals}
        actorsAvailability={actorsAvailability}
        backgroundActorsAvailability={backgroundActorsAvailability}
        crewMemberAvailability={crewMemberAvailability}
        locationsAvailability={locationsAvailability}
        readOnly={readOnly}
        filmId={filmId}
        canAccessActors={canAccessActors}
        canAccessBackgroundActors={canAccessBackgroundActors}
        canAccessCrew={canAccessCrew}
        filmName={filmName}
        csvData={csvData}
        updatePersonAvailability={updatePersonAvailability}
        hasChanges={hasChanges}
        onCancelAvailabilityEdit={onCancelAvailabilityEdit}
        onSaveAvailability={onUpdateAvailability}
      />}
    </ScrollIntoView>
  );
};

function mapStateToProps(state) {
  const { schedulingState } = state;
  const availabilityState = schedulingState.availabilityState;
  return {
    errors: availabilityState.errors,
    loading: availabilityState.loading,
    readOnly: availabilityState.readOnly,
    potentialDates: availabilityState.potentialDates,
    datesTotals: availabilityState.datesTotals,
    actorsAvailability: availabilityState.actorsAvailability,
    backgroundActorsAvailability: availabilityState.backgroundActorsAvailability,
    crewMemberAvailability: availabilityState.crewMemberAvailability,
    locationsAvailability: availabilityState.locationsAvailability,
    canAccessActors: availabilityState.canAccessActors,
    canAccessBackgroundActors: availabilityState.canAccessBackgroundActors,
    canAccessCrew: availabilityState.canAccessCrew,
    refetch: availabilityState.refetch,
    filmName: state.filmsState?.userFilm?.name,
    updatedPeople: availabilityState.updatedPeople
  };
}

export default connect(mapStateToProps,
  {
    fetchAvailability,
    updatePersonAvailability,
    updateAvailability,
    clearUpdatedPeople
  })(SchedulingContainer);
